export default __webpack_public_path__ + "static/media/happy_client.cbf36e41.png";